'use strict';

/**
 * @ngdoc overview
 * @name vTvPackageServices
 * @description
 * # Module
 */
angular.module('v-tv-package-services', ['angular-cache', 'lz-string', 'ajoslin.promise-tracker']);